import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Link,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import AppHeader from "./AppHeader";
import {
  callApiGetJson,
  callApiPostJson,
  APIServerURL,
  debugLog,
  callApiText,
  logAccess,
  UIServerURL,
} from "./GlobalSettings";
import auth from "./Security/Auth";
import VideoHandler from "./VideoHandler";
import ShareContentMessage from "./ShareContentMessage";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";

class MMContentDetail extends Component {
  constructor(props) {
    super(props);
    //this._HPEOnBackClick = this._HPEOnBackClick.bind(this);

    this.state = {
      MMContent: this.props._mmContent,
      bShowVideo: false,
      bDownloadVideo: false,
      UserInfo: auth.getUserInfo(),
      bIsShared: false,
      SharedUrl: undefined,
      isFavourite: this.props._mmContent.Content_IsFavorite,
      bLoadingFavUnFavHit: false,
      isFavUnFavdone: false,
    };
    this.sanitizedContentDescription =
      this.sanitizedContentDescription.bind(this);
    this._ShowVideo = this._ShowVideo.bind(this);
    this._CloseVideo = this._CloseVideo.bind(this);
    this._downloadVideo = this._downloadVideo.bind(this);
    this.OnShare = this.OnShare.bind(this);
    this._hideShareContentPopUp = this._hideShareContentPopUp.bind(this);
    this.addToFavReqHandler = this.addToFavReqHandler.bind(this);
  }

  componentDidMount() {}
  /*   _HPEOnBackClick() {
    this.props.history.push("/");
  } */

  sanitizedContentDescription(description) {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  }

  addToFavReqHandler(contentRecord) {
    console.log("Favorite event fired!!");
    // event.stopPropagation();
    var endpoint = "/AllContent/AddorRemoveFavorites";
    var postData = {
      Favorite_ID: null,
      ContentId: contentRecord.Content_ID,
      Action_Type: contentRecord.Content_IsFavorite ? "Delete" : "Insert",
      Content_Type: contentRecord.Content_Type,
    };
    let token = auth.getToken();
    this.setState({ bLoadingFavUnFavHit: true });
    callApiPostJson(endpoint, postData, token).then((data) => {
      //console.log('EventAvailableEventTimes data:', data);
      if (data.Action_Type) {
        /*//This code reloads just the favorites piece.
             this.reloadFavorites();*/
        /*if(this.state.currentSearchObject)
             this._onSearchTextChange(this.state.currentSearchObject, this.state.currentSelectedSuggestion);
             else this.performInitialSearch();*/
        //contentRecord.Content_IsFavorite = true; //this refreshes contentrecord on display
        if (data.Action_Type === "Insert") {
          this.setState({
            isFavourite: true,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*  contentRecord.Content_IsFavorite = true;
                this.showSnack("Content added to My Favorites. Reloading..."); */
        } else {
          this.setState({
            isFavourite: false,
            bLoadingFavUnFavHit: false,
            isFavUnFavdone: true,
          });
          /*                 contentRecord.Content_IsFavorite = false;
                this.showSnack("Content removed from My Favorites.  Reloading..."); */
        }
      }
    });
  }

  _hideShareContentPopUp() {
    this.setState({ SharedUrl: undefined, bIsShared: false });
    // this.props.hide();
  }

  OnShare() {
    var lnk =
      UIServerURL +
      "?name=" +
      encodeURIComponent(this.props._mmContent.Content_Title);
    this.setState({ SharedUrl: lnk, bIsShared: true });
  }

  _downloadVideo(contentRecord) {
    //event.stopPropagation();
    var endpoint =
      "/MultimediaContent/GetMMStreamURL/" + contentRecord.Content_ID;
    let token = auth.getToken();
    callApiText(endpoint, token).then((data) => {
      debugLog(" BC URL:");
      debugLog(data);
      if (data !== undefined) {
        var elem = window.document.createElement("a");
        elem.href = data;
        elem.target = "_blank";
        elem.download =
          contentRecord.Content_Title + "." + contentRecord.Content_Format;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
      //this.showSnack(data);
      //this.props.removeRatings(index);
    });
    auth.verifyToken(true);
    logAccess(
      contentRecord.Content_ID,
      contentRecord.Content_Type,
      "DownloadVideo",
      this.props.calledBy,
      token
    );
  }

  _ShowVideo() {
    this.setState({ bShowVideo: true });
  }

  _CloseVideo() {
    this.setState({ bShowVideo: false });
  }

  render() {
    var MMCont = this.state.MMContent
      ? this.state.MMContent
      : this.props.props._mmContent;

    var UInfo = this.state.UserInfo ? this.state.UserInfo : undefined;

    var Cont_Prods = "";

    if (this.state.MMContent.Content_Products) {
      this.state.MMContent.Content_Products.map((item) => {
        if (Cont_Prods !== "") {
          Cont_Prods = Cont_Prods + "," + item.ProductName;
        } else {
          Cont_Prods = item.ProductName;
        }
      });
    }

    var bVideoOverlay = this.state.bShowVideo;
    var bVideoDownload = this.state.bDownloadVideo;

    var bIsTobeShared = this.state.bIsShared;
    var SharedLnk = this.state.SharedUrl;

    var IsCont_Favorite = this.state.isFavourite;

    var spinnercontent = "";
    if (this.state.bLoadingFavUnFavHit) {
      spinnercontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Updating your Favourites...</Text>
          </Box>
        </Layer>
      );
    }

    var Fav_UnFav_Done = this.state.isFavUnFavdone;

    /*  var bIsDownloadable = false;

    if (
      this.state.MMContent.Content_BrightcoveID &&
      !this.state.MMContent.Content_Link
    ) {
      bIsDownloadable = true;
    } */

    return (
      <Layer full="true" position="center">
        {spinnercontent}
        <Box fill="vertical" align="stretch" justify="start">
          <Main
            overflow="auto"
            background={{ image: "url('')" }}
            flex
            align="stretch"
            justify="start"
          >
            <AppHeader />
            <Box
              align="stretch"
              justify="center"
              flex="grow"
              background={{ color: "background-back" }}
              direction="row"
            >
              <Box
                align="stretch"
                justify="start"
                flex="shrink"
                pad={{ horizontal: "large", vertical: "medium" }}
                gap="medium"
                basis="xlarge"
              >
                <Box align="center" justify="end" direction="row">
                  <Button
                    icon={<Close />}
                    onClick={this.props.hide}
                    secondary
                  />
                </Box>
                <Header
                  align="start"
                  direction="column"
                  flex={false}
                  justify="start"
                  gap="xxsmall"
                >
                  {/* <Button label="Back" icon={<FormPrevious />} gap="xsmall" onClick={() => push("/home")} /> */}
                  <Box
                    align="center"
                    justify="between"
                    direction="row"
                    alignSelf="stretch"
                  >
                    <Box
                      align="center"
                      justify="center"
                      direction="row"
                      gap="xsmall"
                    >
                      <Heading margin="none">{MMCont.Content_Title}</Heading>
                    </Box>
                    <Box align="center" justify="center" direction="row">
                      {/* <Button icon={<Like />} hoverIndicator />
                      <Button icon={<Dislike />} hoverIndicator /> */}
                      {IsCont_Favorite ? (
                        <Button
                          // icon={<FavoriteIcon style={{ color: "red" }} />}
                          icon={
                            <FavoriteIcon
                              color="secondary"
                              style={{ fontSize: 40 }}
                            />
                          }
                          // hoverIndicator
                          active={false}
                          disabled={Fav_UnFav_Done}
                          reverse={false}
                          secondary={false}
                          onClick={(contentRecord) => {
                            this.addToFavReqHandler(MMCont);
                          }}
                          //primary
                        />
                      ) : (
                        <Button
                          icon={
                            <FavoriteBorderIcon
                              style={{ fontSize: 40, color: "green" }}
                            />
                          }
                          // hoverIndicator
                          active={false}
                          disabled={Fav_UnFav_Done}
                          reverse={false}
                          secondary={false}
                          onClick={(contentRecord) => {
                            this.addToFavReqHandler(MMCont);
                          }}
                          //primary
                        />
                      )}
                    </Box>
                  </Box>
                </Header>
                <Box
                  align="stretch"
                  justify="between"
                  direction="row-responsive"
                  gap="medium"
                >
                  <Card pad="medium" flex="grow">
                    <Box align="center" justify="between" direction="row">
                      <Heading level="1" size="small" margin={{ top: "none" }}>
                        Description
                      </Heading>
                      <DropButton
                        dropAlign={{ top: "bottom" }}
                        dropContent={
                          <Box
                            align="start"
                            justify="start"
                            pad="medium"
                            name="dropContent"
                          >
                            <Grid columns={["small", "medium"]}>
                              <Text>Last Updated</Text>
                              <Text>
                                {MMCont.Content_ModifiedDate
                                  ? new Date(
                                      MMCont.Content_ModifiedDate
                                    ).toString()
                                  : new Date(
                                      MMCont.Content_CreatedDate
                                    ).toString()}
                              </Text>
                              <Text>Author</Text>
                              <Text>{MMCont.Content_Author}</Text>
                              <Text>Technical level</Text>
                              <Text>
                                {MMCont.Content_ExpertiseLevel
                                  ? MMCont.Content_ExpertiseLevel
                                      .ExpertLevelName
                                  : " No Expertise Tagged"}
                              </Text>
                              <Text>Products</Text>
                              <Text>{Cont_Prods}</Text>
                              <Text>Keywords</Text>
                              <Text>{MMCont.Content_Keyword}</Text>
                              <Text>Languages/Subtitles</Text>
                              <Text>{MMCont.Content_Language}</Text>
                            </Grid>
                          </Box>
                        }
                        icon={<More />}
                        secondary={false}
                      />
                    </Box>
                    <Paragraph margin={{ bottom: "none" }} fill>
                      {this.sanitizedContentDescription(
                        MMCont.Content_Description
                      )}
                    </Paragraph>
                  </Card>
                </Box>
                <Footer
                  align="center"
                  direction="row"
                  flex={false}
                  justify="end"
                  gap="medium"
                  margin={{ vertical: "small" }}
                >
                  {/*                   <Button
                    label="Yammer post"
                    icon={<Chat />}
                    secondary={false}
                  /> */}
                  <Button
                    label="Copy Url"
                    icon={<Link />}
                    secondary={false}
                    onClick={this.OnShare}
                  />
                  {MMCont.Content_BrightcoveID ? (
                    <Button
                      label="Download"
                      icon={<Download />}
                      secondary={false}
                      primary={false}
                      onClick={(contentRecord) => {
                        this._downloadVideo(MMCont);
                      }}
                      //disabled={true}
                    />
                  ) : (
                    <Button
                      label="Download"
                      icon={<Download />}
                      secondary={false}
                      primary={false}
                      disabled={true}
                    />
                  )}
                  {bVideoOverlay && (
                    <VideoHandler
                      VideoContentRecord={MMCont}
                      hide={this._CloseVideo}
                      UserType={UInfo.UsertypeID}
                      calledBy={this.props.calledBy}
                    />
                  )}
                  <Button
                    label="Play"
                    primary={false}
                    icon={<Play />}
                    secondary
                    onClick={this._ShowVideo}
                  />
                  {bIsTobeShared && SharedLnk && (
                    <ShareContentMessage
                      url={SharedLnk}
                      hide={this._hideShareContentPopUp}
                    />
                  )}
                </Footer>
              </Box>
            </Box>
          </Main>
        </Box>
      </Layer>
    );
  }
}

export default MMContentDetail;
